import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Trophy } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

function Metric({ label, value }) {
  return (
    <div className="bg-white border border-zinc-200 p-4 rounded-md">
      <div className="text-xs uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="mt-2 font-mono text-2xl font-semibold">{value}</div>
    </div>
  );
}

export default function AthleteStats() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/stats/athlete/${id}`).then((r) => setD(r.data)); }, [id]);
  if (!d) return <div className="text-zinc-500">Caricamento…</div>;

  return (
    <div className="space-y-6">
      <Link to="/statistiche" className="text-sm text-zinc-500 flex items-center gap-1 hover:text-black"><ArrowLeft className="w-4 h-4" />Torna alle statistiche</Link>
      <div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">{d.athlete.first_name} {d.athlete.last_name}</h1>
        <div className="text-sm text-zinc-500 font-mono mt-1 capitalize">{d.athlete.weapon} · {d.athlete.monitoring_level}</div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <Metric label="Assalti" value={d.totals.bouts} />
        <Metric label="Vittorie" value={d.totals.wins} />
        <Metric label="% Vittorie" value={`${d.totals.win_rate}%`} />
        <Metric label="Gare" value={d.totals.competitions} />
        <Metric label="Lezioni" value={d.totals.lessons} />
      </div>

      <section className="bg-white border border-zinc-200 rounded-md p-5">
        <h2 className="font-heading font-semibold mb-4">Trend assalti + vittorie</h2>
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={d.monthly_trend} margin={{ top: 5, right: 20, bottom: 5, left: -10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E7" />
            <XAxis dataKey="month" tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }} />
            <YAxis tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }} />
            <Tooltip contentStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="bouts" stroke="#09090B" strokeWidth={2} name="Assalti" />
            <Line type="monotone" dataKey="wins" stroke="#0052FF" strokeWidth={2} name="Vittorie" />
          </LineChart>
        </ResponsiveContainer>
      </section>

      <section className="bg-white border border-zinc-200 rounded-md">
        <div className="px-5 py-4 border-b border-zinc-200 flex items-center gap-2">
          <Trophy className="w-4 h-4 text-zinc-400" />
          <h2 className="font-heading font-semibold">Storico piazzamenti in gara</h2>
        </div>
        <table className="w-full">
          <thead className="text-xs uppercase tracking-wider text-zinc-500">
            <tr><th className="text-left px-5 py-3">Data</th><th className="text-left px-5 py-3">Gara</th><th className="text-left px-5 py-3">Classifica</th></tr>
          </thead>
          <tbody>
            {d.rankings.map((r, i) => (
              <tr key={i} className="border-t border-zinc-100">
                <td className="px-5 py-3 font-mono text-sm">{r.date}</td>
                <td className="px-5 py-3">{r.name}</td>
                <td className="px-5 py-3 font-mono">#{r.ranking} / {r.participants || "—"}</td>
              </tr>
            ))}
            {d.rankings.length === 0 && <tr><td colSpan={3} className="px-5 py-6 text-center text-zinc-500 text-sm">Nessun piazzamento registrato.</td></tr>}
          </tbody>
        </table>
      </section>
    </div>
  );
}
